import * as React from "react";

const CheckmarkGylph: React.FC = () => {
    return <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Carousels/Standard" transform="translate(-20.000000, -442.000000)" fill="currentColor">
            <g id="Inventory" transform="translate(20.000000, 440.000000)">
                <g id="Group-3" transform="translate(0.000000, 1.000000)">
                    <path d="M7,1 C3.15,1 0,4.15 0,8 C0,11.85 3.15,15 7,15 C10.85,15 14,11.85 14,8 C14,4.15 10.85,1 7,1 L7,1 Z M5.8625,11.0625 L2.975,8.0875 L4.2,6.8625 L5.8625,8.525 L9.45,4.9375 L10.675,6.1625 L5.8625,11.0625 L5.8625,11.0625 Z" id="checkmark--glyph"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(CheckmarkGylph);
